import { useCallback } from 'react';
import { BASE_MODAL } from './utils';

type TUseBaseModalConfig = {
	preventClose: boolean;
	titleId: string | undefined;
	description: React.ReactNode;
};

type TUseBaseModalReturn = {
	handleInteractOutside: (event: Event) => void;
	handleEscapeKeyDown: (event: KeyboardEvent) => void;
	descriptionId: string | undefined;
};

const useBaseModal = ({ preventClose, titleId, description }: TUseBaseModalConfig): TUseBaseModalReturn => {
	const handleInteractOutside = useCallback(
		(event: Event) => {
			if (preventClose) event.preventDefault();
		},
		[preventClose]
	);

	const handleEscapeKeyDown = useCallback(
		(event: KeyboardEvent) => {
			if (preventClose) event.preventDefault();
		},
		[preventClose]
	);

	const descriptionId = description
		? `${titleId ?? BASE_MODAL.DEFAULT_TITLE_ID}${BASE_MODAL.DESCRIPTION_ID_SUFFIX}`
		: undefined;

	return { handleInteractOutside, handleEscapeKeyDown, descriptionId };
};

export { useBaseModal };
